import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.693 2.068c.33-.13.753-.078 1.214.193l10.808 6.367-2.73 2.729-9.292-9.289zm-.628.786l9.213 9.21-9.184 9.18A2.053 2.053 0 0 1 4 20.598V3.401c0-.202.023-.385.065-.547zm13.46 12.042l-2.833-2.832 2.912-2.912 2.93 1.726c1.048.617 1.048 1.627 0 2.245l-3.01 1.773zm-.89.523l-10.73 6.32c-.416.245-.802.312-1.116.225l9.196-9.193 2.65 2.648z"
});

var SvgPlayStore = function SvgPlayStore(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgPlayStore;